import { render, staticRenderFns } from "./TopOfWeek.vue?vue&type=template&id=66a75552&"
import script from "./TopOfWeek.vue?vue&type=script&lang=ts&"
export * from "./TopOfWeek.vue?vue&type=script&lang=ts&"
import style0 from "./TopOfWeek.vue?vue&type=style&index=0&id=66a75552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports